export const getCoords = (suggestion) => {
    return suggestion.geometry
        ? new Promise((resolve) =>
            resolve({
                lat: suggestion.geometry.coordinates[1],
                lon: suggestion.geometry.coordinates[0]
            }))
        : fetch(`/api/suggestion/coords?prefixe=${suggestion.properties.prefix}&numero=${suggestion.properties.housenumber}&voie=${suggestion.properties.street}&suffixe=${suggestion.properties.suffix}&commune=${suggestion.properties.city}&codePostal=${suggestion.properties.postcode}`)
            .then(res => res.json())
            .then(coords => {
                return coords;
            });
};
